module.exports = __webpack_public_path__ + "media/images/support/geolocation/geolocation-safari-permission-1-889ca46afc1b2d658d6695f58513e353.png";